import Cookies from 'js-cookie'

const TokenKey = 'authorization_en'
const userInfoKey = 'userInfo_en'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getInLive() {
  return Cookies.get('inLive')
}

export function setInLive() {
  return Cookies.set('inLive', 1)
}

export function removeInLive() {
  return Cookies.remove('inLive')
}

export function getTimeStamp() {
  return Cookies.get('onlineTimeStamp')
}

export function setTimeStamp(timeStamp) {
  return Cookies.set('onlineTimeStamp', timeStamp)
}

export function removeTimeStamp() {
  return Cookies.remove('onlineTimeStamp')
}

export function getUser() {
  var userinfo = null
  if (Cookies.get(userInfoKey) != '' && Cookies.get(userInfoKey) != undefined) {
    userinfo = JSON.parse(Cookies.get(userInfoKey))
  }
  return userinfo
}

export function setUser(userInfo) {
  return Cookies.set(userInfoKey, JSON.stringify(userInfo))
}

export function removeUser() {
  return Cookies.remove(userInfoKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js